import type { TFunction } from 'i18next';

export type LabelKey = {
	key: string;
	params?: Record<string, string | number>;
};

export const labelKey = (
	key: string,
	params?: Record<string, string | number>
): LabelKey => (params ? { key, params } : { key });

export const translateLabel = (t: TFunction, label: LabelKey): string =>
	t(label.key, label.params ?? {});
